import type { SurveyOption } from '../../SimpleSurvey';

export const surveyOptions: SurveyOption[] = [
  {
    id: 'freelance-designer',
    label: 'Freelance Designer',
  },
  {
    id: 'designer-company',
    label: 'Designer at a Company',
  },
  {
    id: 'designer-studio',
    label: 'Designer in a Studio or Agency',
  },
  {
    id: 'solo-entrepreneur',
    label: 'Solo Entrepreneur',
  },
  {
    id: 'content-creator',
    label: 'Content Creator or Blogger',
  },
  {
    id: 'student-teacher',
    label: 'Student or Teacher',
  },
  {
    id: 'hobbyist-designer',
    label: 'Hobbyist Designer',
  },
];
